import { appendParamsToUrl } from 'widgets/toolbox/util';

import { TButtonInstance } from 'widgets/global/Button';

type TButtonPrefs = ReturnType<TButtonInstance['prefs']>;

interface IBonusButtonInstance extends TButtonInstance {
    prefs(): TButtonPrefs & {
        duuid: string;
        pliuuid: string;
        bonusUrl: string;
        bonusProductTitle: string;
    };
}

/**
 * @description CartWithBonusMixin implementation
 * @param CartMgr Base widget for extending
 * @returns widget which handles Bonus Product functionality on cart
 */
function CartWithBonusMixinClassCreator(CartMgr: import('widgets/cart/CartMgr').TCartMgr) {
    /**
     * @category widgets
     * @subcategory product
     * @class CartWithBonusMixin
     * @classdesc Represents CartWithBonusMixin component with next features:
     * 1. Triggers cart re render if bonus products were updated
     * 2. Shows Bonus Product dialog for adding and editing
     * @augments CartMgr
     */
    class CartWithBonusMixin extends CartMgr {
        prefs() {
            return {
                bonusProductTitle: '',
                ...super.prefs()
            };
        }

        init() {
            super.init();
            this.eventBus().on('bonus.updated', 'onBonusUpdated');
        }

        /**
         * @description Executes on bonus updated in Edit Mode
         * @param response Response object from server
         */
        onBonusUpdated(response) {
            const cart = response;

            if (cart) {
                this.renderCart(cart);
            }
        }

        /**
         * @description retrieves data for show bonus modal and opens it
         * @param button processButton widget
         */
        showBonusProductDialog(button: IBonusButtonInstance) {
            const bonusUrl = appendParamsToUrl(button.prefs().bonusUrl, {
                from: 'cart',
                DUUID: button.prefs().duuid,
                pliuuid: button.prefs().pliuuid
            });

            this.eventBus().emit('dialogshow', {
                type: 'bonusproduct',
                url: bonusUrl,
                headerText: button.prefs().bonusProductTitle,
                wrapperClasses: 'm-bonus_product'
            });
        }
    }

    return CartWithBonusMixin;
}

export type TCartWithBonusMixin = ReturnType<typeof CartWithBonusMixinClassCreator>;

export type TCartWithBonusMixinInstance = InstanceType<TCartWithBonusMixin>;

export default CartWithBonusMixinClassCreator;
